export interface UserLevel {
  id: number;
  name: string;
}

export enum UserLevelNames {
  Admin = 1,
  Employee = 2,
  DealerUser = 3,
  Inactive = 4,
}
